/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var E;!function(E){E[E.NONE=0]="NONE",E[E.SPLIT=1]="SPLIT",E[E.ELEVATION=2]="ELEVATION",E[E.MERGE=4]="MERGE",E[E.RENDERDATA=8]="RENDERDATA",E[E.GEOMETRY=16]="GEOMETRY",E[E.TEXTURE_NOFADING=32]="TEXTURE_NOFADING",E[E.TEXTURE_FADING=64]="TEXTURE_FADING"}(E||(E={}));export{E as TileUpdate};
